export interface FacebookPage {
  id: string;
  name: string;
  access_token: string;
}

export const exampleFacebookPage: FacebookPage = {
  id: '1',
  name: 'Test',
  access_token: '321',
};

export interface FBPagePicture {
  height: number;
  is_silhouette: boolean;
  url: string;
  width: number;
}

export const exampleFBPagePicture: FBPagePicture = {
  height: 50,
  is_silhouette: false,
  url: 'https://facebookurl/img',
  width: 50,
};

export interface FBPageName {
  id: string;
  name: string;
}

export const exampleFBPageName = { id: '123', name: 'Bruce Chiropractic' };

/** `phone` is absent when the Page lists none. */
export interface FBPagePhone {
  id: string;
  phone?: string;
}
